import { put, takeLatest, delay } from "redux-saga/effects";
import { deleteAccountApi } from "store/api/LoginApi";
import { DELETE_ACCOUNT_ACTION } from "../../actions/LoginPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* deleteAccount(action) {
	yield put(globalAction.openLoadingPage());
	const { type, reason, onSuccess } = action.params;
	const data = {
		type: type,
		reason: reason
	};
	const res = yield deleteAccountApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* deleteAccountSaga() {
	yield takeLatest(DELETE_ACCOUNT_ACTION, deleteAccount);
}

export default deleteAccountSaga;
